import { useState } from 'react';
import { InternalTab } from '..';
import { useGetInternalDashboardQuery } from '../../api/internal';
import { Tabs, TabsContent } from '../../components/Tabs';
import { useDateRange } from '../../hooks/useDateRange';
import { useTenantIds } from '../../hooks/useTenantIds';
import { InternalDashboardSkeleton } from '../components/InternalDashboardSkeleton';
import { LifeglovsTab } from './LifeglovsTab';
import { SessionsTab } from './SessionsTab';
import { SurveysTab } from './SurveysTab';
import { UtilizationTab } from './UtilizationTab';

function defaultSessionsDateRange(): [Date, Date] {
  // Past three months (inclusive of the current month)
  const start = new Date();
  start.setDate(1);
  start.setMonth(start.getMonth() - 2);
  return [start, new Date()];
}

export function InternalDashboard() {
  const [activeTab, setActiveTab] = useState<string>(InternalTab.Utilization);
  const [utilizationDateRange, setUtilizationDateRange] = useState<[Date, Date] | null>(null);
  const [sessionsDateRange, setSessionsDateRange] = useState<[Date, Date] | null>(defaultSessionsDateRange);

  const dateRange = activeTab === InternalTab.Utilization ? utilizationDateRange : sessionsDateRange;
  const { dateFrom, dateTo } = useDateRange(dateRange);

  const tenantIds = useTenantIds();
  const { data, isLoading } = useGetInternalDashboardQuery({ tenantIds, dateFrom, dateTo });

  const latestLifeglovUsage = data?.latestLifeglovUsage ?? {};
  const sessions = data?.sessions ?? [];
  const patients = data?.patients ?? [];

  if (isLoading) {
    return <InternalDashboardSkeleton />;
  }

  return (
    <Tabs defaultValue={InternalTab.Utilization} onValueChange={setActiveTab} className="flex-1 flex-col">
      <TabsContent value={InternalTab.Utilization}>
        <UtilizationTab
          sessions={sessions}
          patients={patients}
          dateRange={utilizationDateRange}
          onDateRangeChange={setUtilizationDateRange}
        />
      </TabsContent>

      <TabsContent value={InternalTab.Sessions}>
        <SessionsTab sessions={sessions} dateRange={sessionsDateRange} onDateRangeChange={setSessionsDateRange} />
      </TabsContent>

      <TabsContent value={InternalTab.Lifeglovs}>
        <LifeglovsTab latestLifeglovUsage={latestLifeglovUsage} />
      </TabsContent>

      <TabsContent value={InternalTab.Surveys}>
        <SurveysTab />
      </TabsContent>
    </Tabs>
  );
}
